const BOX_OPTIONS = "api/broylesllc/box-configs?limit=500";

const numberField = (key, label) => ({ key, label, type: "number" });

const photos = (key, label) => ({
    key,
    label,
    readOnly: true,
    source: "Photos on this variant",
});

/** Editable GCS photo uploads (same storage as Product images). */
const photoUpload = (key, label, { maxCount = 20, hint } = {}) => ({
    key,
    label,
    type: "photos",
    maxCount,
    hint:
        hint ||
        "Stored with Product images in GCS. Shown on Inspection Wizard variant cards.",
});

const configLink = (key, label) => ({
    key,
    label,
    type: "link",
    optionLabel: "internalName",
    optionsEndpoint: BOX_OPTIONS,
    hint: "Box configuration cost this pack is built from",
});

const dim = (key, label, source = "From the linked config name") => ({
    key,
    label,
    readOnly: true,
    source,
});

const FORMULA_PACKS = [
    ["single", "Single"],
    ["singleBiab", "Single BIAB"],
    ["double", "Double"],
    ["doubleBiab", "Double BIAB"],
    ["pack3x", "3x"],
    ["pack3xBiab", "3x BIAB"],
    ["pack4x", "4x"],
    ["pack4xBiab", "4x BIAB"],
];

function formulaDims(kind, heightSource) {
    return FORMULA_PACKS.map(([key, label]) =>
        dim(
            `${key}${kind}`,
            `${label} - ${kind}`,
            key === "pack3xBiab" && kind === "Height"
                ? "From the 3x config name"
                : key === "pack4xBiab" && kind === "Height"
                  ? "From the 4x config name"
                  : heightSource
        )
    );
}

export const VARIANT_SPEC = {
    title: "variants",
    singular: "Variant",
    endpoint: "broylesllc/variants",
    maxWidth: "md",
    fields: [
        {
            key: "label",
            label: "Label",
            readOnly: true,
            source: "Internal SKU ID prefix, year, box value, UPC, and MPN",
        },
        {
            key: "heroPhoto",
            label: "Hero Photo",
            readOnly: true,
            source: "Uses the linked Product's Hero image",
        },
        {
            key: "product",
            label: "Product",
            type: "link",
            optionLabel: "internalSkuId",
            optionFallback: "itemName",
            optionsEndpoint: "api/broylesllc/products?limit=500",
            hint: "SKU this variant belongs to",
        },
        {
            key: "internalSkuId",
            label: "Internal SKU ID",
            readOnly: true,
            source: "Lookup from the linked Product",
        },
        { key: "yearApprox", label: "Year (Approx)" },
        { key: "boxValue", label: "Box Value" },
        { key: "mpn", label: "MPN" },
        { key: "upc", label: "UPC" },
        photoUpload("internalPackagePhotos", "Variant Photos", {
            maxCount: 20,
            hint: "Extra photos for the Inspection Wizard carousel (Product Hero is always first).",
        }),
        numberField("retailWeight", "Retail - Weight"),
        numberField("retailLength", "Retail - Length"),
        numberField("retailWidth", "Retail - Width"),
        numberField("retailHeight", "Retail - Height"),
        photos("retailShipPics", "Retail - Ship Config Pics"),
        numberField("singleWeight", "Single - Weight"),
        photos("singleShipPics", "Single - Ship Config Pics"),
        configLink("singleConfig", "Single - Config"),
        numberField("singleBiabWeight", "Single BIAB - Weight"),
        photos("singleBiabShipPics", "Single BIAB - Ship Config Pics"),
        configLink("singleBiabConfig", "Single BIAB - Config"),
        numberField("doubleWeight", "Double - Weight"),
        photos("doubleShipPics", "Double - Ship Config Pics"),
        numberField("doubleBiabWeight", "Double BIAB - Weight"),
        photos("doubleBiabShipPics", "Double BIAB - Ship Config Pics"),
        configLink("doubleConfig", "Double - Config"),
        configLink("doubleBiabConfig", "Double BIAB - Config"),
        numberField("pack3xWeight", "3x - Weight"),
        photos("pack3xShipPics", "3x - Ship Config Pics"),
        configLink("pack3xConfig", "3x - Config"),
        numberField("pack3xBiabWeight", "3x BIAB - Weight"),
        photos("pack3xBiabShipPics", "3x BIAB - Ship Config Pics"),
        configLink("pack3xBiabConfig", "3x BIAB - Config"),
        numberField("pack4xWeight", "4x - Weight"),
        photos("pack4xShipPics", "4x - Ship Config Pics"),
        configLink("pack4xConfig", "4x - Config"),
        numberField("pack4xBiabWeight", "4x BIAB - Weight"),
        photos("pack4xBiabShipPics", "4x BIAB - Ship Config Pics"),
        configLink("pack4xBiabConfig", "4x BIAB - Config"),
        {
            key: "customPacks",
            label: "Custom pack types",
            type: "customPacks",
            optionLabel: "internalName",
            optionsEndpoint: BOX_OPTIONS,
            hint: "Pack types beyond 4x (e.g. 5x) saved from shipping",
        },
        ...formulaDims("Length"),
        ...formulaDims("Width"),
        ...formulaDims("Height"),
        {
            key: "notesOnLargerQuantitiesOrExceptions",
            label: "Notes on Larger Quantities or Exceptions",
            type: "notes",
        },
    ],
};
